(function () {
  function initWedcharmProducts() {
    document.querySelectorAll('[data-wc-product]').forEach((root) => {
      if (root.dataset.wcProductInitialized === 'true') {
        return;
      }

      root.dataset.wcProductInitialized = 'true';

      const variantsNode = root.querySelector('[data-wc-variants-json]');
      let variants = [];

      try {
        variants = variantsNode
          ? JSON.parse(variantsNode.textContent)
          : [];
      } catch (error) {
        variants = [];
      }

      const form = root.querySelector('[data-wc-product-form]');
      const variantInput = root.querySelector('[data-wc-variant-id]');
      const priceWrap = root.querySelector('[data-wc-price]');
      const skuNode = root.querySelector('[data-wc-sku]');

      const atcButton = root.querySelector('[data-wc-atc]');
      const atcText = root.querySelector('[data-wc-atc-text]');

      const stickyAtcButton = root.querySelector(
        '[data-wc-sticky-atc]'
      );

      const stickyAtcText = root.querySelector(
        '[data-wc-sticky-atc-text]'
      );

      const stickyPriceNode = root.querySelector(
        '[data-wc-sticky-price]'
      );

      const stickyAtcBar = root.querySelector(
        '[data-wc-sticky-atc-bar]'
      );

      const dynamicCheckoutWrap = root.querySelector(
        '[data-wc-dynamic-checkout]'
      );

      const atcButtons = [
        atcButton,
        stickyAtcButton
      ].filter(Boolean);

      const atcTextNodes = [
        atcText,
        stickyAtcText
      ].filter(Boolean);

      const moneyFormat =
        root.dataset.moneyFormat || '{{amount}}';

      const gallery = root.querySelector(
        '[data-wc-pdp-gallery]'
      );

      const nativeSizeGroup = root.querySelector(
        '[data-wc-native-size-option]'
      );

      const sizeModeInputs = root.querySelectorAll(
        '[data-wc-size-mode]'
      );

      const standardSizeWrap = root.querySelector(
        '[data-wc-standard-sizes]'
      );

      const standardSizeButtons = root.querySelectorAll(
        '[data-wc-standard-size]'
      );

      const customChoice = root.querySelector(
        '[data-wc-custom-choice]'
      );

      const measurementsProperty = root.querySelector(
        '[data-wc-measurements-property]'
      );

      const measureNowButton = root.querySelector(
        '[data-wc-measure-now]'
      );

      const measureLaterButton = root.querySelector(
        '[data-wc-measure-later]'
      );

      const measurementPopup = root.querySelector(
        '[data-wc-measure-popup]'
      );

      const measurementFields = root.querySelectorAll(
        '[data-wc-measure-field]'
      );

      const measurementRequiredFields = root.querySelectorAll(
        '[data-wc-measure-required]'
      );

      const saveMeasurementsButton = root.querySelector(
        '[data-wc-save-measurements]'
      );

      const closeMeasurementPopupButtons =
        root.querySelectorAll(
          '[data-wc-close-measure-popup]'
        );

      const sizeGuidePopup = root.querySelector(
        '[data-wc-size-guide-popup]'
      );

      const openSizeGuideButtons = root.querySelectorAll(
        '[data-wc-open-size-guide-popup]'
      );

      const closeSizeGuideButtons = root.querySelectorAll(
        '[data-wc-close-size-guide-popup]'
      );

      const openQuestionsLinks = root.querySelectorAll(
        '[data-wc-open-questions]'
      );

      const questionsPanel = root.querySelector(
        '[data-wc-questions-panel]'
      );

      /*
        Stores the last selected standard size for the current product page.
      */
      let lastStandardSize = '';

      function initQuestionsLink() {
        if (!questionsPanel || !openQuestionsLinks.length) {
          return;
        }

        function getStickyHeaderHeight() {
          const header = document.querySelector('[data-header]');

          if (!header) {
            return 0;
          }

          return Math.ceil(
            header.getBoundingClientRect().height
          );
        }

        function scrollToQuestions() {
          const panelTop =
            window.scrollY +
            questionsPanel.getBoundingClientRect().top;

          const scrollOffset =
            getStickyHeaderHeight() + 10;

          window.scrollTo({
            top: Math.max(0, panelTop - scrollOffset),
            behavior: 'smooth'
          });
        }

        openQuestionsLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            questionsPanel.open = true;

            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                scrollToQuestions();

                if (
                  window.history &&
                  window.history.replaceState
                ) {
                  window.history.replaceState(
                    null,
                    '',
                    `#${questionsPanel.id}`
                  );
                }
              });
            });
          });
        });
      }

      function formatMoney(cents) {
        const value = Number(cents || 0);
        const amount = (value / 100).toFixed(2);

        const amountNoDecimals = String(
          Math.round(value / 100)
        );

        const amountWithComma = amount.replace('.', ',');

        return moneyFormat
          .replace(
            /\{\{\s*amount\s*\}\}/,
            amount
          )
          .replace(
            /\{\{\s*amount_no_decimals\s*\}\}/,
            amountNoDecimals
          )
          .replace(
            /\{\{\s*amount_with_comma_separator\s*\}\}/,
            amountWithComma
          );
      }

      function ensurePriceNodes() {
        if (!priceWrap) {
          return {
            current: null,
            compare: null
          };
        }

        let currentPriceNode =
          priceWrap.querySelector(
            '[data-wc-current-price]'
          ) ||
          priceWrap.querySelector(
            '.wc-pdp-buybox__price-current'
          );

        let comparePriceNode =
          priceWrap.querySelector(
            '[data-wc-compare-price]'
          ) ||
          priceWrap.querySelector(
            '.wc-pdp-buybox__price-compare'
          );

        if (!currentPriceNode) {
          currentPriceNode =
            document.createElement('span');

          currentPriceNode.className =
            'wc-pdp-buybox__price-current';

          priceWrap.appendChild(currentPriceNode);
        }

        if (!comparePriceNode) {
          comparePriceNode =
            document.createElement('span');

          comparePriceNode.className =
            'wc-pdp-buybox__price-compare';

          comparePriceNode.hidden = true;

          priceWrap.appendChild(comparePriceNode);
        }

        currentPriceNode.setAttribute(
          'data-wc-current-price',
          ''
        );

        comparePriceNode.setAttribute(
          'data-wc-compare-price',
          ''
        );

        return {
          current: currentPriceNode,
          compare: comparePriceNode
        };
      }

      function updatePrice(variant) {
        if (!variant) {
          return;
        }

        const priceNodes = ensurePriceNodes();
        const currentPriceNode = priceNodes.current;
        const comparePriceNode = priceNodes.compare;

        const price = Number(
          variant.price || 0
        );

        const compareAtPrice = Number(
          variant.compare_at_price || 0
        );

        if (
          currentPriceNode &&
          typeof variant.price !== 'undefined'
        ) {
          currentPriceNode.textContent =
            formatMoney(price);
        }

        if (
          stickyPriceNode &&
          typeof variant.price !== 'undefined'
        ) {
          stickyPriceNode.textContent =
            formatMoney(price);
        }

        if (comparePriceNode) {
          if (compareAtPrice > price) {
            comparePriceNode.textContent =
              formatMoney(compareAtPrice);

            comparePriceNode.hidden = false;

            comparePriceNode.removeAttribute(
              'hidden'
            );

            if (priceWrap) {
              priceWrap.classList.add(
                'has-compare-price'
              );
            }
          } else {
            comparePriceNode.textContent = '';
            comparePriceNode.hidden = true;

            comparePriceNode.setAttribute(
              'hidden',
              ''
            );

            if (priceWrap) {
              priceWrap.classList.remove(
                'has-compare-price'
              );
            }
          }
        }
      }

      function getSelectedOptions() {
        return Array.from(
          root.querySelectorAll(
            '[data-wc-option-group]'
          )
        ).map((group) => {
          const checkedInput = group.querySelector(
            '[data-wc-option-input]:checked'
          );

          return checkedInput
            ? checkedInput.value
            : null;
        });
      }

      function findVariant() {
        const selectedOptions =
          getSelectedOptions();

        if (
          !selectedOptions.length ||
          !variants.length ||
          selectedOptions.some(
            (optionValue) => optionValue === null
          )
        ) {
          return null;
        }

        return (
          variants.find((variant) => {
            if (!Array.isArray(variant.options)) {
              return false;
            }

            return variant.options.every(
              (optionValue, index) => {
                return (
                  String(optionValue) ===
                  String(selectedOptions[index])
                );
              }
            );
          }) || null
        );
      }

      function findVariantForMedia() {
        const selectedOptions =
          getSelectedOptions();

        if (
          !selectedOptions.length ||
          !variants.length ||
          selectedOptions.every(
            (optionValue) => optionValue === null
          )
        ) {
          return null;
        }

        const matchingVariants =
          variants.filter((variant) => {
            if (!Array.isArray(variant.options)) {
              return false;
            }

            return selectedOptions.every(
              (selectedValue, index) => {
                return (
                  selectedValue === null ||
                  String(variant.options[index]) ===
                    String(selectedValue)
                );
              }
            );
          });

        if (!matchingVariants.length) {
          return null;
        }

        const hasMedia = (variant) => {
          return Boolean(
            variant.featured_media_id ||
            variant.featured_image_id ||
            variant.featured_image_src
          );
        };

        return (
          matchingVariants.find(
            (variant) =>
              variant.available &&
              hasMedia(variant)
          ) ||
          matchingVariants.find(hasMedia) ||
          matchingVariants.find(
            (variant) => variant.available
          ) ||
          matchingVariants[0]
        );
      }

      function updateVariantMedia(variant) {
        if (!gallery || !variant) {
          return;
        }

        const mediaId =
          variant.featured_media_id ||
          (
            variant.featured_media &&
            variant.featured_media.id
          ) ||
          '';

        const imageId =
          variant.featured_image_id ||
          (
            variant.featured_image &&
            variant.featured_image.id
          ) ||
          '';

        const imageSrc =
          variant.featured_image_src ||
          (
            variant.featured_image &&
            variant.featured_image.src
          ) ||
          '';

        if (!mediaId && !imageId && !imageSrc) {
          return;
        }

        const detail = {
          mediaId: mediaId,
          imageId: imageId,
          imageSrc: imageSrc
        };

        if (
          typeof gallery.wcSetActiveMediaFromVariant ===
          'function'
        ) {
          gallery.wcSetActiveMediaFromVariant(
            detail
          );

          return;
        }

        gallery.dispatchEvent(
          new CustomEvent(
            'wc:variant-media-change',
            {
              detail: detail,
              bubbles: true
            }
          )
        );
      }

      if (gallery) {
        gallery.addEventListener(
          'wc:gallery-ready',
          function () {
            updateVariantMedia(
              findVariant()
            );
          }
        );
      }

      function setStickyAtcVisible(isVisible) {
        if (!stickyAtcBar) {
          return;
        }

        stickyAtcBar.classList.toggle(
          'is-visible',
          isVisible
        );

        document.body.classList.toggle(
          'wc-product-sticky-atc-visible',
          isVisible
        );
      }

      function initStickyAtcVisibility() {
        if (!stickyAtcBar || !atcButton) {
          setStickyAtcVisible(false);
          return;
        }

        setStickyAtcVisible(false);

        function shouldShowStickyButton() {
          const rect =
            atcButton.getBoundingClientRect();

          return rect.bottom < 0;
        }

        function updateStickyAtcVisibility() {
          setStickyAtcVisible(
            shouldShowStickyButton()
          );
        }

        if ('IntersectionObserver' in window) {
          const observer =
            new IntersectionObserver(
              (entries) => {
                const entry = entries[0];

                if (!entry) {
                  updateStickyAtcVisibility();
                  return;
                }

                const originalButtonIsAboveViewport =
                  entry.boundingClientRect.bottom < 0;

                const shouldShow =
                  !entry.isIntersecting &&
                  originalButtonIsAboveViewport;

                setStickyAtcVisible(
                  shouldShow
                );
              },
              {
                threshold: 0
              }
            );

          observer.observe(atcButton);
        } else {
          window.addEventListener(
            'scroll',
            updateStickyAtcVisibility,
            {
              passive: true
            }
          );

          window.addEventListener(
            'resize',
            updateStickyAtcVisibility
          );

          updateStickyAtcVisibility();
        }
      }

      function scrollToSizeSelector() {
        const target =
          standardSizeWrap ||
          nativeSizeGroup ||
          root.querySelector(
            '[data-wc-size-selector]'
          );

        if (!target) {
          return;
        }

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        /*
          Briefly highlights the size selector.
        */
        if (
          typeof target.animate === 'function'
        ) {
          target.animate(
            [
              {
                boxShadow:
                  '0 0 0 0 rgba(37, 31, 28, 0)'
              },
              {
                boxShadow:
                  '0 0 0 5px rgba(37, 31, 28, 0.14)'
              },
              {
                boxShadow:
                  '0 0 0 0 rgba(37, 31, 28, 0)'
              }
            ],
            {
              duration: 1400,
              easing: 'ease'
            }
          );
        }

        const firstAvailableSize =
          Array.from(
            standardSizeButtons
          ).find((button) => {
            return !button.disabled;
          });

        window.setTimeout(() => {
          if (firstAvailableSize) {
            firstAvailableSize.focus({
              preventScroll: true
            });
          }
        }, 500);
      }

      function getNativeSizeInput(value) {
        if (!nativeSizeGroup) {
          return null;
        }

        const targetValue = String(
          value || ''
        ).toLowerCase();

        return (
          Array.from(
            nativeSizeGroup.querySelectorAll(
              '[data-wc-option-input]'
            )
          ).find((input) => {
            return (
              String(
                input.value || ''
              ).toLowerCase() ===
              targetValue
            );
          }) || null
        );
      }

      function getCurrentNativeSize() {
        if (!nativeSizeGroup) {
          return '';
        }

        const checkedInput =
          nativeSizeGroup.querySelector(
            '[data-wc-option-input]:checked'
          );

        return checkedInput
          ? checkedInput.value
          : '';
      }

      function setNativeSize(value) {
        const input =
          getNativeSizeInput(value);

        if (!input || input.disabled) {
          return false;
        }

        input.checked = true;

        return true;
      }

      function rememberStandardSize(value) {
        const normalizedValue = String(
          value || ''
        ).trim();

        if (
          !normalizedValue ||
          normalizedValue.toLowerCase() ===
            'custom'
        ) {
          return;
        }

        lastStandardSize = normalizedValue;
      }

      function canRestoreStandardSize(value) {
        const normalizedValue = String(
          value || ''
        ).trim();

        if (!normalizedValue) {
          return false;
        }

        const matchingButton =
          Array.from(
            standardSizeButtons
          ).find((button) => {
            return (
              String(
                button.dataset
                  .wcStandardSize || ''
              ).toLowerCase() ===
              normalizedValue.toLowerCase()
            );
          });

        if (
          matchingButton &&
          matchingButton.disabled
        ) {
          return false;
        }

        const matchingInput =
          getNativeSizeInput(
            normalizedValue
          );

        return Boolean(
          matchingInput &&
          !matchingInput.disabled
        );
      }

      function clearNativeSize() {
        if (!nativeSizeGroup) {
          return;
        }

        nativeSizeGroup
          .querySelectorAll(
            '[data-wc-option-input]'
          )
          .forEach((input) => {
            input.checked = false;
          });

        if (variantInput) {
          variantInput.value = '';
        }

        if (
          window.history &&
          window.history.replaceState
        ) {
          const url = new URL(
            window.location.href
          );

          url.searchParams.delete(
            'variant'
          );

          window.history.replaceState(
            {},
            '',
            url.toString()
          );
        }
      }

      function restoreLastStandardSize() {
        if (
          !canRestoreStandardSize(
            lastStandardSize
          )
        ) {
          clearNativeSize();
          return false;
        }

        return setNativeSize(
          lastStandardSize
        );
      }

      function updateVariant() {
        const variant = findVariant();

        const sizeSelectionMissing =
          Boolean(
            nativeSizeGroup &&
            !getCurrentNativeSize()
          );

        if (!variant) {
          if (variantInput) {
            variantInput.value = '';
          }

          /*
            Keeps the main add-to-cart button disabled until a standard size is selected.
          */
          if (atcButton) {
            atcButton.disabled = true;
          }

          /*
            Keeps the sticky size button available so it can scroll to the size selector.
          */
          if (stickyAtcButton) {
            if (sizeSelectionMissing) {
              stickyAtcButton.disabled =
                false;

              stickyAtcButton.classList.add(
                'is-select-size'
              );

              stickyAtcButton.setAttribute(
                'aria-label',
                'Select a size'
              );
            } else {
              stickyAtcButton.disabled =
                true;

              stickyAtcButton.classList.remove(
                'is-select-size'
              );

              stickyAtcButton.removeAttribute(
                'aria-label'
              );
            }
          }

          atcTextNodes.forEach(
            (textNode) => {
              textNode.textContent =
                sizeSelectionMissing
                  ? (
                    textNode.dataset
                      .selectSizeText ||
                    'Select a size'
                  )
                  : (
                    textNode.dataset
                      .soldOutText ||
                    'Sold out'
                  );
            }
          );

          if (dynamicCheckoutWrap) {
            dynamicCheckoutWrap.hidden =
              true;
          }

          return;
        }

        if (variantInput) {
          variantInput.value = variant.id;
        }

        if (stickyAtcButton) {
          stickyAtcButton.classList.remove(
            'is-select-size'
          );

          stickyAtcButton.removeAttribute(
            'aria-label'
          );
        }

        updatePrice(variant);
        updateVariantMedia(variant);

        if (skuNode) {
          skuNode.textContent =
            variant.sku || '';
        }

        atcButtons.forEach((button) => {
          button.disabled =
            !variant.available;
        });

        atcTextNodes.forEach(
          (textNode) => {
            textNode.textContent =
              variant.available
                ? (
                  textNode.dataset
                    .availableText ||
                  'Add to bag'
                )
                : (
                  textNode.dataset
                    .soldOutText ||
                  'Sold out'
                );
          }
        );

        if (dynamicCheckoutWrap) {
          dynamicCheckoutWrap.hidden =
            !variant.available;
        }

        if (
          variant.id &&
          window.history &&
          window.history.replaceState
        ) {
          const url = new URL(
            window.location.href
          );

          url.searchParams.set(
            'variant',
            variant.id
          );

          window.history.replaceState(
            {},
            '',
            url.toString()
          );
        }
      }

      function setMeasurementChoice(value) {
        if (!measurementsProperty) {
          return;
        }

        measurementsProperty.disabled = false;

        measurementsProperty.value =
          value || '';
      }

      function enableMeasurementFields(enable) {
        measurementFields.forEach(
          (field) => {
            field.disabled = !enable;

            if (!enable) {
              field.required = false;
            }
          }
        );

        measurementRequiredFields.forEach(
          (field) => {
            field.required =
              Boolean(enable);
          }
        );
      }

      function clearMeasurementButtons() {
        if (measureNowButton) {
          measureNowButton.classList.remove(
            'is-active'
          );
        }

        if (measureLaterButton) {
          measureLaterButton.classList.remove(
            'is-active'
          );
        }
      }

      function setMeasurementsLater() {
        setMeasurementChoice(
          'Input measurements later'
        );

        enableMeasurementFields(false);
        clearMeasurementButtons();

        if (measureLaterButton) {
          measureLaterButton.classList.add(
            'is-active'
          );
        }

        closeMeasurePopup();
      }

      function openMeasurePopup() {
        if (!measurementPopup) {
          return;
        }

        measurementPopup.hidden = false;

        document.documentElement.classList.add(
          'wc-measure-popup-open'
        );
      }

      function closeMeasurePopup() {
        if (!measurementPopup) {
          return;
        }

        measurementPopup.hidden = true;

        document.documentElement.classList.remove(
          'wc-measure-popup-open'
        );
      }

      function openSizeGuidePopup() {
        if (!sizeGuidePopup) {
          return;
        }

        sizeGuidePopup.hidden = false;

        document.documentElement.classList.add(
          'wc-size-guide-popup-open'
        );
      }

      function closeSizeGuidePopup() {
        if (!sizeGuidePopup) {
          return;
        }

        sizeGuidePopup.hidden = true;

        document.documentElement.classList.remove(
          'wc-size-guide-popup-open'
        );
      }

      function disableCustomMeasurements() {
        if (measurementsProperty) {
          measurementsProperty.value = '';
          measurementsProperty.disabled =
            true;
        }

        clearMeasurementButtons();
        enableMeasurementFields(false);
        closeMeasurePopup();
      }

      function syncSizeUi() {
        const currentSize =
          getCurrentNativeSize();

        const isCustom =
          String(
            currentSize
          ).toLowerCase() === 'custom';

        sizeModeInputs.forEach((input) => {
          if (
            input.dataset.wcSizeModeValue ===
            'custom'
          ) {
            input.checked = isCustom;
          }

          if (
            input.dataset.wcSizeModeValue ===
            'standard'
          ) {
            input.checked = !isCustom;
          }
        });

        if (standardSizeWrap) {
          standardSizeWrap.hidden =
            isCustom;
        }

        if (customChoice) {
          customChoice.hidden =
            !isCustom;
        }

        if (measurementsProperty) {
          measurementsProperty.disabled =
            !isCustom;
        }

        standardSizeButtons.forEach(
          (button) => {
            const buttonSize =
              button.dataset.wcStandardSize;

            const isSelected =
              String(buttonSize) ===
              String(currentSize);

            button.classList.toggle(
              'is-active',
              isSelected
            );

            button.classList.toggle(
              'is-selected',
              isSelected
            );

            button.setAttribute(
              'aria-pressed',
              isSelected
                ? 'true'
                : 'false'
            );
          }
        );

        if (!isCustom) {
          disableCustomMeasurements();
        }
      }

      function validateMeasurementsPopup() {
        let isValid = true;
        let firstInvalid = null;

        measurementRequiredFields.forEach(
          (field) => {
            if (
              !field.disabled &&
              !String(
                field.value || ''
              ).trim()
            ) {
              isValid = false;

              if (!firstInvalid) {
                firstInvalid = field;
              }

              field.classList.add(
                'is-error'
              );
            } else {
              field.classList.remove(
                'is-error'
              );
            }
          }
        );

        if (
          !isValid &&
          firstInvalid
        ) {
          firstInvalid.focus();
        }

        return isValid;
      }

      function isColorOptionInput(input) {
        if (!input) {
          return false;
        }

        const optionName = String(
          input.getAttribute('name') || ''
        ).toLowerCase();

        const optionGroup = input.closest(
          '[data-wc-option-group]'
        );

        const optionLegend = optionGroup
          ? optionGroup.querySelector('legend')
          : null;

        const optionLabel = String(
          optionLegend
            ? optionLegend.textContent || ''
            : ''
        ).trim().toLowerCase();

        return (
          optionName.includes('color') ||
          optionName.includes('colour') ||
          optionName.includes('цвет') ||
          optionName.includes('колір') ||
          optionLabel.includes('color') ||
          optionLabel.includes('colour') ||
          optionLabel.includes('цвет') ||
          optionLabel.includes('колір')
        );
      }

      /*
        Remembers a standard size selected through the variant URL.
      */
      rememberStandardSize(
        getCurrentNativeSize()
      );

      root
        .querySelectorAll(
          '[data-wc-option-input]'
        )
        .forEach((input) => {
          input.addEventListener(
            'change',
            () => {
              if (!input.checked) {
                return;
              }

              const isSizeInput = Boolean(
                nativeSizeGroup &&
                nativeSizeGroup.contains(input)
              );

              const isColorInput =
                isColorOptionInput(input);

              if (isSizeInput) {
                rememberStandardSize(
                  input.value
                );
              }

              updateVariant();
              syncSizeUi();

              /*
                Changes gallery media only after the customer
                actively selects a color. On initial page load,
                the product's first image remains visible.
              */
              if (
                isColorInput &&
                !findVariant()
              ) {
                updateVariantMedia(
                  findVariantForMedia()
                );
              }
            }
          );

          /*
            A checked radio does not emit another change event.
            This click handler lets the customer reopen the media
            for a color that was already selected on page load.
          */
          input.addEventListener(
            'click',
            () => {
              if (
                !input.checked ||
                !isColorOptionInput(input)
              ) {
                return;
              }

              updateVariantMedia(
                findVariant() ||
                findVariantForMedia()
              );
            }
          );
        });

      sizeModeInputs.forEach((input) => {
        input.addEventListener(
          'change',
          () => {
            if (!input.checked) {
              return;
            }

            if (
              input.dataset.wcSizeModeValue ===
              'custom'
            ) {
              /*
                Remembers the last selected standard size.
              */
              rememberStandardSize(
                getCurrentNativeSize()
              );

              setNativeSize('Custom');

              /*
                Uses the measurements-later option by default for a custom size.
              */
              setMeasurementsLater();

              syncSizeUi();
              updateVariant();

              return;
            }

            if (
              input.dataset.wcSizeModeValue ===
              'standard'
            ) {
              disableCustomMeasurements();

              /*
                Restores the previously selected standard size.
              */
              restoreLastStandardSize();

              syncSizeUi();
              updateVariant();
            }
          }
        );
      });

      standardSizeButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              if (button.disabled) {
                return;
              }

              disableCustomMeasurements();

              const selectedSize =
                button.dataset.wcStandardSize;

              if (
                setNativeSize(selectedSize)
              ) {
                rememberStandardSize(
                  selectedSize
                );
              }

              syncSizeUi();
              updateVariant();
            }
          );
        }
      );

      if (measureNowButton) {
        measureNowButton.addEventListener(
          'click',
          () => {
            rememberStandardSize(
              getCurrentNativeSize()
            );

            setNativeSize('Custom');

            setMeasurementChoice(
              'Input measurements now'
            );

            enableMeasurementFields(true);
            clearMeasurementButtons();

            measureNowButton.classList.add(
              'is-active'
            );

            syncSizeUi();
            updateVariant();
            openMeasurePopup();
          }
        );
      }

      if (measureLaterButton) {
        measureLaterButton.addEventListener(
          'click',
          () => {
            rememberStandardSize(
              getCurrentNativeSize()
            );

            setNativeSize('Custom');
            setMeasurementsLater();

            syncSizeUi();
            updateVariant();
          }
        );
      }

      closeMeasurementPopupButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            closeMeasurePopup
          );
        }
      );

      if (saveMeasurementsButton) {
        saveMeasurementsButton.addEventListener(
          'click',
          () => {
            if (
              !validateMeasurementsPopup()
            ) {
              return;
            }

            setMeasurementChoice(
              'Input measurements now'
            );

            if (measureNowButton) {
              clearMeasurementButtons();

              measureNowButton.classList.add(
                'is-active'
              );
            }

            closeMeasurePopup();
          }
        );
      }

      openSizeGuideButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            openSizeGuidePopup
          );
        }
      );

      closeSizeGuideButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            closeSizeGuidePopup
          );
        }
      );

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape') {
            return;
          }

          closeMeasurePopup();
          closeSizeGuidePopup();
        }
      );

      /*
        Scrolls the sticky size action to the size selector.
      */
      if (stickyAtcButton) {
        stickyAtcButton.addEventListener(
          'click',
          (event) => {
            const sizeIsMissing =
              Boolean(
                nativeSizeGroup &&
                !getCurrentNativeSize()
              );

            if (!sizeIsMissing) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();

            scrollToSizeSelector();
          }
        );
      }

      if (form) {
        form.addEventListener(
          'submit',
          (event) => {
            const currentSize =
              getCurrentNativeSize();

            const isCustom =
              String(
                currentSize
              ).toLowerCase() ===
              'custom';

            if (
              nativeSizeGroup &&
              !currentSize
            ) {
              event.preventDefault();

              scrollToSizeSelector();

              return;
            }

            /*
              Provides a fallback when the custom-size property is still empty.
            */
            if (
              isCustom &&
              measurementsProperty &&
              !String(
                measurementsProperty.value ||
                ''
              ).trim()
            ) {
              setMeasurementsLater();
            }

            if (
              isCustom &&
              measurementsProperty &&
              measurementsProperty.value ===
                'Input measurements now' &&
              !validateMeasurementsPopup()
            ) {
              event.preventDefault();
              openMeasurePopup();

              return;
            }

            atcButtons.forEach(
              (button) => {
                button.classList.add(
                  'is-loading'
                );
              }
            );
          }
        );
      }

      function initWishlistButton() {
        const wishlistButton =
          root.querySelector(
            '[data-wc-wishlist]'
          );

        if (!wishlistButton) {
          return;
        }

        const handle =
          wishlistButton.dataset
            .productHandle;

        if (!handle) {
          return;
        }

        const storageKey =
          'wc_wishlist_products';

        function getWishlist() {
          try {
            const raw =
              localStorage.getItem(
                storageKey
              );

            const items =
              JSON.parse(raw) || [];

            if (!Array.isArray(items)) {
              return [];
            }

            return Array.from(
              new Set(
                items.filter(Boolean)
              )
            );
          } catch (error) {
            return [];
          }
        }

        function setWishlist(items) {
          const cleanItems =
            Array.from(
              new Set(
                items.filter(Boolean)
              )
            );

          localStorage.setItem(
            storageKey,
            JSON.stringify(cleanItems)
          );

          window.dispatchEvent(
            new CustomEvent(
              'wc:wishlist:updated',
              {
                detail: {
                  items: cleanItems
                }
              }
            )
          );
        }

        function updateButtonState() {
          const wishlist =
            getWishlist();

          const isActive =
            wishlist.includes(handle);

          wishlistButton.classList.toggle(
            'is-active',
            isActive
          );

          wishlistButton.setAttribute(
            'aria-pressed',
            isActive
              ? 'true'
              : 'false'
          );

          wishlistButton.setAttribute(
            'aria-label',
            isActive
              ? 'Remove from wishlist'
              : 'Add to wishlist'
          );
        }

        wishlistButton.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();

            let wishlist =
              getWishlist();

            if (
              wishlist.includes(handle)
            ) {
              wishlist =
                wishlist.filter(
                  (item) =>
                    item !== handle
                );
            } else {
              wishlist.push(handle);
            }

            setWishlist(wishlist);
            updateButtonState();
          }
        );

        updateButtonState();

        window.addEventListener(
          'storage',
          (event) => {
            if (
              event.key === storageKey
            ) {
              updateButtonState();
            }
          }
        );

        window.addEventListener(
          'wc:wishlist:updated',
          () => {
            updateButtonState();
          }
        );
      }

      initWishlistButton();

      /*
        Sets measurements later when the page opens with the custom variant selected.
      */
      if (
        String(
          getCurrentNativeSize()
        ).toLowerCase() === 'custom' &&
        measurementsProperty &&
        !String(
          measurementsProperty.value || ''
        ).trim()
      ) {
        setMeasurementsLater();
      }

      initQuestionsLink();
      syncSizeUi();
      updateVariant();
      initStickyAtcVisibility();
    });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initWedcharmProducts
    );
  } else {
    initWedcharmProducts();
  }

  document.addEventListener(
    'shopify:section:load',
    initWedcharmProducts
  );
})();